//热门城市推荐

export const popularCity = [
  {
    id: '91faf610954811ecbc9f37991c82aec4',
    name: 'Teterboro Airport',
    location: '{"lati": 40.8501014708999, "long": -74.060798645}',
    hot: 419,
    timezone: 'America/New_York',
    code: 'TEB',
    icao: 'KTEB',
    stateName: 'New York',
    cityNames: 'New York',
    airportType: 'Medium_Airport',
    stateCode: 'NY',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '4f4f8ea08e2911ec83a7c138e70cc816',
    name: 'Van Nuys Airport',
    location: '{"lati": 34.209800720215, "long": -118.48999786377}',
    hot: 685,
    timezone: 'America/Los_Angeles',
    code: 'VNY',
    icao: 'KVNY',
    stateName: 'California',
    cityNames: 'Los Angeles',
    airportType: 'Medium_Airport',
    stateCode: 'CA',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '3c8f99908e2911ec83a7c138e70cc816',
    name: 'John Wayne Airport-Orange County Airport',
    location: '{"lati": 33.675701, "long": -117.867996}',
    hot: 448,
    timezone: 'America/Los_Angeles',
    code: 'SNA',
    icao: 'KSNA',
    stateName: 'California',
    cityNames: 'Santa Ana',
    airportType: 'Medium_Airport',
    stateCode: 'CA',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '5ee3d1208e2711ec83a7c138e70cc816',
    name: 'Lester B. Pearson International Airport',
    location: '{"lati": 43.6772003174, "long": -79.6305999755999}',
    hot: 524,
    timezone: 'America/Toronto',
    code: 'YYZ',
    icao: 'CYYZ',
    stateName: 'Ontario',
    cityNames: 'Toronto',
    airportType: 'Large_Airport',
    stateCode: 'ON',
    countryIso2: 'CA',
    countryIso3: 'CAN',
    idType: "airport",
  },
  {
    id: '5beb78b08e2711ec83a7c138e70cc816',
    name: 'Vancouver International Airport',
    location: '{"lati": 49.193901062, "long": -123.183998108}',
    hot: 140,
    timezone: 'America/Vancouver',
    code: 'YVR',
    icao: 'CYVR',
    stateName: 'British Columbia',
    cityNames: 'Vancouver',
    airportType: 'Large_Airport',
    stateCode: 'BC',
    countryIso2: 'CA',
    countryIso3: 'CAN',
    idType: "airport",
  },
  {
    id: 'fc29da008e2811ec83a7c138e70cc816',
    name: 'McCarran International Airport',
    location: '{"lati": 36.08010101, "long": -115.1520004}',
    hot: 471,
    timezone: 'America/Los_Angeles',
    code: 'LAS',
    icao: 'KLAS',
    stateName: 'Nevada',
    cityNames: 'Las Vegas',
    airportType: 'Large_Airport',
    stateCode: 'NV',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '398dcb408e2911ec83a7c138e70cc816',
    name: 'San Francisco International Airport',
    location: '{"lati": 37.6189994812011, "long": -122.375}',
    hot: 33,
    timezone: 'America/Los_Angeles',
    code: 'SFO',
    icao: 'KSFO',
    stateName: 'California',
    cityNames: 'San Francisco',
    airportType: 'Large_Airport',
    stateCode: 'CA',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: 'a2654fa08e2711ec83a7c138e70cc816',
    name: 'London Luton Airport',
    location: '{"lati": 51.874698638916, "long": -0.368333011865615}',
    hot: 48,
    timezone: 'Europe/London',
    code: 'LTN',
    icao: 'EGGW',
    stateName: 'England',
    cityNames: 'London',
    airportType: 'Large_Airport',
    stateCode: 'ENG',
    countryIso2: 'GB',
    countryIso3: 'GBR',
    idType: "airport",
  },
  {
    id: '5b0e38108e2711ec83a7c138e70cc816',
    name: 'Montreal / Pierre Elliott Trudeau International Airport',
    location: '{"lati": 45.4706001282, "long": -73.7407989502}',
    hot: 49,
    timezone: 'America/Toronto',
    code: 'YUL',
    icao: 'CYUL',
    stateName: 'Quebec',
    cityNames: 'Montréal',
    airportType: 'Large_Airport',
    stateCode: 'QC',
    countryIso2: 'CA',
    countryIso3: 'CAN',
    idType: "airport",
  },
  {
    id: '1ff29e408e2911ec83a7c138e70cc816',
    name: 'Miami-Opa Locka Executive Airport',
    location: '{"lati": 25.907, "long": -80.278397}',
    hot: 13,
    timezone: 'America/New_York',
    code: 'OPF',
    icao: 'KOPF',
    stateName: 'Florida',
    cityNames: 'Miami',
    airportType: 'Medium_Airport',
    stateCode: 'FL',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: 'c4f17fc08e2811ec83a7c138e70cc816',
    name: 'Dallas Love Field',
    location: '{"lati": 32.847099, "long": -96.851799}',
    hot: 9,
    timezone: 'America/Chicago',
    code: 'DAL',
    icao: 'KDAL',
    stateName: 'Texas',
    cityNames: 'Dallas',
    airportType: 'Medium_Airport',
    stateCode: 'TX',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: 'a48d43408e2811ec83a7c138e70cc816',
    name: 'Addison Airport',
    location: '{"lati": 32.9686012268, "long": -96.8364028931}',
    hot: 32,
    timezone: 'America/Chicago',
    code: 'ADS',
    icao: 'KADS',
    stateName: 'Texas',
    cityNames: 'Dallas',
    airportType: 'Small_Airport',
    stateCode: 'TX',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: 'af7b6b608e2811ec83a7c138e70cc816',
    name: 'Boeing Field King County International Airport',
    location: '{"lati": 47.529999, "long": -122.302002}',
    hot: 6,
    timezone: 'America/Los_Angeles',
    code: 'BFI',
    icao: 'KBFI',
    stateName: 'Washington',
    cityNames: 'Seattle',
    airportType: 'Medium_Airport',
    stateCode: 'WA',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '09010d708e2911ec83a7c138e70cc816',
    name: 'Orlando International Airport',
    location: '{"lati": 28.4293994903564, "long": -81.3089981079101}',
    hot: 33,
    timezone: 'America/New_York',
    code: 'MCO',
    icao: 'KMCO',
    stateName: 'Florida',
    cityNames: 'Orlando',
    airportType: 'Large_Airport',
    stateCode: 'FL',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '20d55d208e2911ec83a7c138e70cc816',
    name: 'Orlando Executive Airport',
    location: '{"lati": 28.5455, "long": -81.332901}',
    hot: 3,
    timezone: 'America/New_York',
    code: 'ORL',
    icao: 'KORL',
    stateName: 'Florida',
    cityNames: 'Orlando',
    airportType: 'Small_Airport',
    stateCode: 'FL',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '90fa34d08e2a11ec83a7c138e70cc816',
    name: 'Daniel K Inouye International Airport',
    location: '{"lati": 21.32062, "long": -157.924228}',
    hot: 42,
    timezone: 'Pacific/Honolulu',
    code: 'HNL',
    icao: 'PHNL',
    stateName: 'Hawaii',
    cityNames: 'Honolulu',
    airportType: 'Large_Airport',
    stateCode: 'HI',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: 'b30555708e2811ec83a7c138e70cc816',
    name: 'Logan International Airport',
    location: '{"lati": 42.3643, "long": -71.005203}',
    hot: 3,
    timezone: 'America/New_York',
    code: 'BOS',
    icao: 'KBOS',
    stateName: 'Massachusetts',
    cityNames: 'Boston',
    airportType: 'Large_Airport',
    stateCode: 'MA',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: 'af19c3608e2811ec83a7c138e70cc816',
    name: 'Laurence G Hanscom Field',
    location: '{"lati": 42.47000122, "long": -71.28900146}',
    hot: 3,
    timezone: 'America/New_York',
    code: 'BED',
    icao: 'KBED',
    stateName: 'Massachusetts',
    cityNames: 'Bedford',
    airportType: 'Medium_Airport',
    stateCode: 'MA',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '5f12a9508e2711ec83a7c138e70cc816',
    name: 'Yellowknife International Airport',
    location: '{"lati": 62.462799, "long": -114.440002}',
    hot: 18,
    timezone: 'America/Yellowknife',
    code: 'YZF',
    icao: 'CYZF',
    stateName: 'Northwest Territories',
    cityNames: 'Yellowknife',
    airportType: 'Medium_Airport',
    stateCode: 'NT',
    countryIso2: 'CA',
    countryIso3: 'CAN',
    idType: "airport",
  },
  {
    id: '09b765208e2911ec83a7c138e70cc816',
    name: 'Chicago Midway International Airport',
    location: '{"lati": 41.785999, "long": -87.752403}',
    hot: 2,
    timezone: 'America/Chicago',
    code: 'MDW',
    icao: 'KMDW',
    stateName: 'Illinois',
    cityNames: 'Chicago',
    airportType: 'Large_Airport',
    stateCode: 'IL',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '9165baf0954811ecbc9f37991c82aec4',
    name: 'Chicago Executive Airport',
    location: '{"lati": 42.114222, "long": -87.901494}',
    timezone: 'America/Chicago',
    code: 'PWK',
    icao: 'KPWK',
    stateName: 'Illinois',
    cityNames: 'Chicago;Prospect Heights;Wheeling',
    airportType: 'Medium_Airport',
    stateCode: 'IL',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: 'dacb42808e2911ec83a7c138e70cc816',
    name: 'Cancún International Airport',
    location: '{"lati": 21.0365009308, "long": -86.8770980835}',
    hot: 11,
    timezone: 'America/Cancun',
    code: 'CUN',
    icao: 'MMUN',
    stateName: 'Quintana Roo',
    cityNames: 'Cancún',
    airportType: 'Large_Airport',
    stateCode: 'ROO',
    countryIso2: 'MX',
    countryIso3: 'MEX',
    idType: "airport",
  },
  {
    id: 'ea3412c08e2811ec83a7c138e70cc816',
    name: 'William P Hobby Airport',
    location: '{"lati": 29.645399, "long": -95.2789}',
    hot: 2,
    timezone: 'America/Chicago',
    code: 'HOU',
    icao: 'KHOU',
    stateName: 'Texas',
    cityNames: 'Houston',
    airportType: 'Medium_Airport',
    stateCode: 'TX',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  },
  {
    id: '8f24a490954811ecbc9f37991c82aec4',
    name: 'Ronald Reagan Washington National Airport',
    location: '{"lati": 38.8521, "long": -77.037697}',
    hot: 2,
    timezone: 'America/New_York',
    code: 'DCA',
    icao: 'KDCA',
    stateName: 'District of Columbia',
    cityNames: 'Washington D.C.',
    airportType: 'Large_Airport',
    stateCode: 'DC',
    countryIso2: 'US',
    countryIso3: 'USA',
    idType: "airport",
  }
]